import React, {Component} from 'react';
import userImage from '../../assets/128x128.jpg';

import api from '../../utils/api';
import moment from 'moment';
import $ from 'jquery';
import 'emojione-picker/css/picker.css';
import EmojiPicker from 'emojione-picker';
import jwt from 'jsonwebtoken';

import {NotificationManager} from 'react-notifications';


class TicketView extends Component {
    constructor(props){
        super(props);
        this.state = {
            socket: null,
            currentThread: null,
            currentMessageThread: {},
            content: '',
            sidebarOpened: false,
            loading: false,
            online: true,
            changingStatus: false,
            activeAttachmentView: 'Pictures',
            searchFiles: '',
            galleryActive: false,
            galleryIndex: 0,
            userSearch: '',
            lecture: '',
            test: '',
            showLectures: true,
            showTest: false,
            askingQuestion: false,
            askedQuestion: false,
            question: ''
        }
    }
    
    componentDidMount = () => {
        if(this.props.match.params.subjectId){
            let command = jwt.sign({
                command: {
                type: 'LOAD_TICKETS',
                profileId: this.props.user.user.Profile.id,
                subjectId: this.props.match.params.subjectId,
                token: this.props.user.id
            }}, '#&r7%+UbWU8Hc');
            
            if(this.props.socket){
                this.props.socket.send(command);
            }else{
                let self = this;
                setTimeout(function(){
                    self.props.socket.send(command);
                }, 1000);
            }
            this.props.getChatLectures(this.props.match.params.subjectId, this.props.user.id);
        }
    }
    
    
    sendMessage = () => {
        let splitLines = this.state.content.split('\n').filter(l => l !== '');
        
        if(this.props.uploadingMessageFiles.length > 0){
            NotificationManager.error('You have files uploading.  Please wait until these complete.');
        }else if(this.state.content !== '' && (splitLines.length > 0 || this.props.messageFiles.length > 0)){
            if(this.state.askingQuestion === false){
                this.setState({askingQuestion: true});
            }else if(this.state.askingQuestion && (this.state.lecture || this.state.test)){
                
                let thread = {
                    users: [this.props.user.user.Profile.id],
                    question: this.state.content,
                    lecture: this.state.lecture || this.state.test,
                    solved: false,
                    subjectId: this.props.match.params.subjectId,
                    createdAt: new Date(),
                    status: 1,
                    lastActivity: new Date()
                }
                
                let message = {
                    createdAt: new Date(),
                    status: "sent",
                    content: this.state.content,
                    profileId: this.props.user.user.Profile.id
                }
                
                
                let command = jwt.sign({
                                command: {
                                    type: 'CREATE_TICKET',
                                    thread: thread,
                                    message: message,
                                    messageFiles: this.props.messageFiles.map(f => f.id),
                                    token: this.props.user.id
                                }}, '#&r7%+UbWU8Hc');
                this.props.socket.send(command);
                
                this.setState({content: '', lecture: '', test: '', askingQuestion: false, askedQuestion: false});
            }
            
            /*
            let command = jwt.sign({
                command: {
                    type: 'ADD_MESSAGE',
                    message: {
                        createdAt: new Date(),
                        status: "sent",
                        content: self.state.content,
                        threadId: self.props.currentThread,
                        profileId: self.props.user.user.Profile.id
                    },
                    messageFiles: this.props.messageFiles.map(f => f.id),
                    token: this.props.user.id
          
                }}, '#&r7%+UbWU8Hc');
                this.props.socket.send(command);
           
            
            this.props.clearMessageFiles();
            
            command = jwt.sign({
                command: {
                        type: 'IS_TYPING',
                        threadId: self.props.currentThread,
                        id: self.props.user.user.Profile.id,
                        typing: false,
                        token: self.props.user.id
              
                    }}, '#&r7%+UbWU8Hc');
                this.props.socket.send(command);
            
            this.setState({content: ''});
            */
        
        }
    }
    
    updateInput = (e) => {
        let self = this;
        this.setState({content: e.target.value}, () => {
            let thread = {};
            let threadList = self.props.threads.filter(t => t.id === self.props.currentThread);
                
            if(threadList.length > 0){
                thread = threadList[0];
            }
            

            if(thread.typing){
            if(self.state.content !== '' && thread.typing.indexOf(self.props.user.user.Profile.id) === -1){

                   let command = jwt.sign({
                        command: {
                        type: 'IS_TYPING',
                        threadId: self.props.currentThread,
                        id: self.props.user.user.Profile.id,
                        typing: true,
                        token: self.props.user.id
              
                    }}, '#&r7%+UbWU8Hc');
                    this.props.socket.send(command);

            }else if(self.state.content === '' && thread.typing.indexOf(self.props.user.user.Profile.id) > -1){

               let command = jwt.sign({
                        command: {
                        type: 'IS_TYPING',
                        threadId: self.props.currentThread,
                        id: self.props.user.user.Profile.id,
                        typing: false,
                        token: self.props.user.id
              
                    }}, '#&r7%+UbWU8Hc');
                    this.props.socket.send(command);
            }
            }
        })
    }
    
    

    loadMore = () => {
        
        if(this.props.socket && this.props.currentThread){
            let thread = {};
            let threadList = this.props.threads.filter(t => t.id === this.props.match.params.threadId);
                
            if(threadList.length > 0){
                thread = threadList[0];
            }
            
            if(thread.Messages){
                this.setState({loading: true}, () => {
                    let command = jwt.sign({
                                    command: {
                        type: 'LOAD_MORE_MESSAGES',
                        profileId: this.props.user.user.Profile.id,
                        skip: thread.Messages.length,
                        threadId: thread.id,
                        initial: false,
                        token: this.props.user.id
                    }}, '#&r7%+UbWU8Hc');
                    this.props.socket.send(command);
                 
                })
            }
        }
    }
    
    render(){
        
        let {thread, chatSubject} = this.props;
        let subject = null;
        let lecturesInSubject = [];
        
       if(this.props.chatSubject){
            if(this.props.chatSubject.CourseChapter){
                subject = chatSubject;
                chatSubject.CourseChapter.map(c => {
                    return c.ChapterVideo.map(v => {
                        return lecturesInSubject.push(v.title);
                    })
                })
            }
        }
                
        
        return (
            <div className="chat-box">
                <div className="chat-head text-center">
                <div className="flex flex-justify-content-space-between">
                    <div>
                        <h3 id="StackContentHeading">{subject && subject.name}</h3>
                        <div className="stacks-history">
                            <div className="stack-history-item">
                                <span>Total Questions Asked</span><span className="text-info">{this.props.threads.filter(t => t.ticket && t.subjectId === this.props.match.params.subjectId).length}</span>
                            </div>
                            <div className="stack-history-item">
                                <span>Resolved</span><span className="text-success">{this.props.threads.filter(t => t.ticket && t.subjectId === this.props.match.params.subjectId && t.solved).length}</span>
                            </div>
                            <div className="stack-history-item">
                                <span>Unresolved</span><span className="text-orange">{this.props.threads.filter(t =>  t.ticket && t.subjectId === this.props.match.params.subjectId && !t.solved).length}</span>
                            </div>
                        </div>
                    </div>
                    <div>
                           
                        </div>
                        </div>
                </div>
                <div className="chat-contents-wrapper">
                <div className="stacked-wrapped" style={{display: "none"}}>
                        <div className="chat-head text-center">
                            <div className="flex flex-justify-content-space-between">
                                <div>
                                    <h3 id="StackContentHeading">Announcements</h3>
                                    <div className="stacks-history">
                                        <div className="stack-history-item">
                                            <span>Total Questions Asked</span><span className="text-info">20</span>
                                        </div>
                                        <div className="stack-history-item">
                                            <span>Resolved</span><span className="text-success">12</span>
                                        </div>
                                        <div className="stack-history-item">
                                            <span>Unresolved</span><span className="text-orange">8</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="sp-top100">
                                    <div className="sp-50">
                                        <div className="wow fadeInUp animated">
                                            <div className="paper-stack" >
                                                <div className="flex">
                                                    <div className="paper-stack-subject-icon bg-physics">P</div>
                                                    <div className="sp-left10">
                                                        <h3><a >Lecture 1</a></h3>
                                                        <p><a >Precarious beyond ouch armadillo as accurate expediently the begrudging activated jeepers much hugged heron far noiseless allegedly ethereally usefully drew neglectfully poignantly save a oh far that </a></p>
                                                        <span className="label label-danger">12</span>
                                                        <i className="zmdi zmdi-chevron-right"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="wow fadeInUp animated" data-wow-delay="0.2s">
                                            <div className="paper-stack">
                                                <div className="flex">
                                                    <div className="paper-stack-subject-icon bg-physics">P</div>
                                                    <div className="sp-left10">
                                                        <h3><a >Lecture 2</a></h3>
                                                        <p><a >That shark porcupine more ladybug one leopard more dubiously and overslept unsociably less one music poked far wow poked this yikes less salmon dynamically much filled to meadowlark much less so where</a></p>
                                                        <div className="confirmed"><i className="zmdi zmdi-check-circle"></i> Resolved <span>12 Aug 2018</span></div>
                                                        <i className="zmdi zmdi-chevron-right"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="wow fadeInUp animated" data-wow-delay="0.4s" >
                                            <div className="paper-stack">
                                                <div className="flex">
                                                    <div className="paper-stack-subject-icon bg-physics">P</div>
                                                    <div className="sp-left10">
                                                        <h3><a >Lecture 3</a></h3>
                                                        <p><a >Preparatory where ran the facetious woodchuck until over wherever lantern about ouch more luridly overdid above musically much splashed alas meant strode one much far less sensible knitted saucily dre</a></p>
                                                        <span className="label label-danger">16</span>
                                                        <i className="zmdi zmdi-chevron-right"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="wow fadeInUp animated" data-wow-delay="0.6s" >
                                            <div className="paper-stack">
                                                <div className="flex">
                                                    <div className="paper-stack-subject-icon bg-physics">P</div>
                                                    <div className="sp-left10">
                                                        <h3><a >Lecture 4</a></h3>
                                                        <p><a >Some indiscreetly including after far unbound dispassionately petulant far bridled misled jeepers alongside marvelously but built leapt irrespective bound more remade far when noisily dear immaturely </a></p>
                                                        <span className="label label-danger">9</span>
                                                        <i className="zmdi zmdi-chevron-right"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="chat-footer-add-question">
                            <div className="chat-footer-add-question-wrapper">
                                <a  className="HideAddFooterQuestion"><i className="zmdi zmdi-close"></i> </a>
                                <div className="container">
                                    
                                    <div className="row">
                                        <div className="col-sm-2 text-right">
                                            <p>What is this question about?</p>
                                        </div>
                                        <div className="col-sm-10">
                                            <div className="form-group">
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-2 text-right">

                                        </div>
                                        <div className="col-sm-6">
                                            <div className="QuestionTypeLecture">
                                                <select className="form-control">
                                                    <option value="">Choose One</option>
                                                    
                                                </select>
                                            </div>
                                            <div className="QuestionTypePracticeTest" style={{display: "none"}}>
                                                <input type="text" className="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="text-right">
                                <div className="sp-2000">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <textarea className="form-control" id="note"  placeholder="Type Your Question here"></textarea>
                                            <div className="chat-controls">
                                                <div className="visibleAfterClick">
                                                    <a  className="btn btn-primary" onclick="SubmitAddNewQuestionForm()">Ask <i className="zmdi zmdi-mail-send"></i></a>
                                                </div>
                                                <a  className="visibleBeforeClick"><i className="zmdi zmdi-image"></i> </a>
                                                <a  className="text-red visibleBeforeClick" onclick="ShowAddNewQuestionForm()"><i className="zmdi zmdi-mail-send"></i> </a>
                                            </div>
                                        </div>
                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ul className="chat-items-wrapper" style={{paddingTop: "100px"}}>
                        {this.props.threads.filter(t => t.subjectId && t.ticket && t.subjectId === this.props.match.params.subjectId).length > 0 ?
                            this.props.threads.filter(t => t.subjectId && t.ticket && t.subjectId === this.props.match.params.subjectId).map(t => {
                            return (
                                <div className="wow fadeInUp animated" data-wow-delay="0.6s" onClick={e => this.props.history.push('/chat/' + t.id)}>
                                    <div className="paper-stack">
                                        <div className="flex">
                                            <div className="paper-stack-subject-icon bg-physics">{t.lecture ? t.lecture[0] : 'L'}</div>
                                            <div className="sp-left10">
                                                <h3><a >{t.lecture || 'Question'}</a></h3>
                                                <p><a >{t.question}</a></p>
                                                {t.solved &&
                                                    <div className="confirmed"><i className="zmdi zmdi-check-circle"></i> Resolved <span>{moment(t.solvedAt).format('DD MMM YYYY [at] hh:mm A')}</span></div>
                                                }
                                                <span className="label label-danger"></span>
                                                <i className="zmdi zmdi-chevron-right"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                            
                            :
                            (this.props.match.params.threadId === 'tickets' && this.props.match.params.subjectId === this.props.courseUser[0].currentSubject) ?
                            
                                <div className="icon-message">
                                    <i className="zmdi zmdi-help-outline" />
                                    <h1>Confused?</h1>
                                    <p>Ask your instructors a question!</p>
                                </div>
                            
                            :
                            
                                <div className="icon-message">
                                    <i className="zmdi zmdi-help-outline" />
                                    <h1>This is not the thread you're looking for</h1>
                                    <p>You can not send messages for this subject yet!</p>
                                </div>
                            
                        }
                                                
                    </ul>
                </div>
                {this.state.askingQuestion &&
                    <div className="chat-footer-add-question-wrapper" style={{display: "block"}}>
                        <a  className="HideAddFooterQuestion"><i className="zmdi zmdi-close"></i> </a>
                        <div className="container">
                           
                            <div className="row">
                                <div className="col-sm-2 text-right">
                                    <p>What is this question about?</p>
                                </div>
                               <div className="col-sm-10">
                                            <div className="form-group">
                                                <div className="row">
                                                    <div className="col-sm-3">
                                                        <label className="hover">
                                                        <div className={`iradio_square-green ${(this.state.showLectures) ? 'checked hover' : ''}`} aria-checked="false" aria-disabled="false" onClick={e => this.setState({showLectures: true, showTest: false})}>
                                                       
                                                        <ins className="iCheck-helper" ></ins></div> &nbsp;&nbsp; A lecture</label>
                                                    </div>
                                                    <div className="col-sm-3">

                                                        <label>
                                                        <div className={`iradio_square-green ${(this.state.showTest) ? 'checked hover' : ''}`} aria-checked="false" aria-disabled="false" onClick={e => this.setState({showLectures: false, showTest: true})}>
                                        
                                                        <ins className="iCheck-helper" ></ins></div> &nbsp;&nbsp; Practice test</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-2 text-right">
    
                                </div>
                                <div className="col-sm-6">
                                    <div className="QuestionTypeLecture" style={{display: (this.state.showLectures) ? 'block' : "none"}}>
                                        <select className="form-control" value={this.state.lecture} onChange={e => this.setState({lecture: e.target.value})}>
                                            <option value="">Choose One</option>
                                            {lecturesInSubject.map(l => {
                                                return (
                                                    <option value={l}>{l}</option>
                                                )
                                                
                                            })
                                            }
                                        </select>
                                    </div>
                                    
                                    <div className="QuestionTypePracticeTest" style={{display: (this.state.showTest) ? 'block' : "none"}}>
                                        <input type="text" className="form-control" value={this.state.test} onChange={e => this.setState({test: e.target.value})} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                
                <div className="chatbox-input-area" style={{overflow: 'initial'}}>
                <span className="isTyping">
                        {
                            thread &&
                            thread.typing &&
                            thread.typing.length > 0 &&
                            thread.Profiles &&
                            thread.typing.filter(t => t !== this.props.user.user.Profile.id).map((typer, i) => {
                                let profile = thread.Profiles.filter(p => p.id == typer)[0];
                                
                                if(profile){
                                    return (
                                        <span>
                                            {`${i > 0 ? ', ' + profile.name : profile.name}`}
                                        </span>
                                    )
                                }
                            })
                            
                            
                        }
                        
                        {thread &&
                            thread.typing &&
                            thread.typing.length > 0 &&
                            thread.Profiles &&
                            thread.typing.filter(t => t !== this.props.user.user.Profile.id).length > 0 &&
                        <span>{`${(thread.typing.filter(t => t !== this.props.user.user.Profile.id).length > 1) ? ' are typing' : ' is typing'}`}</span>
                        }
                    </span>
                    {(this.props.match.params.threadId === 'tickets' && this.props.match.params.subjectId === this.props.courseUser[0].currentSubject) || this.props.match.params.threadId !== "tickets" ?
                    <div className="chat-input">
                        <div className="chat-controls">
                            <a  onClick={(e) => $('#upload-message-files').trigger('click')}><i className="zmdi zmdi-image"></i> </a>
                            <a  onClick={(e) => $('#upload-message-files').trigger('click')}><i className="zmdi zmdi-file"></i> </a>
                            <input
                                type="file"
                                className="btn btn-file-upload btn-default hidden"
                                id="upload-message-files"
                                onChange={(e) => {
                                    let {files} = this.state;
                                    const data = new FormData();
                                    
                                    this.props.uploadMessageFiles(e.target.files, this.props.user.user.Profile.id, this.props.user.id);
                                    
                                }}
                                multiple="true"
                            />
                            <a href="#CreateNotificationModal" data-toggle="modal"><i className="zmdi zmdi-notifications-active"></i> </a>
                            <a  onClick={e => this.sendMessage()}><i className="zmdi zmdi-mail-send"></i> </a>
                            <span className="dropdown emoji-dropdown">
                                <a className="dropdown-toggle" data-toggle="dropdown" ><i className="zmdi zmdi-mood"></i></a>
                                <div className="dropdown-menu">
                                <EmojiPicker onChange={(data, e) => {
                                  
                                  this.setState({content: this.state.content + ' ' + data.shortname});
                                  return false;
                                }} search={true} />
                                </div>
                            </span>
                        </div>
                        <textarea 
                            className="form-control emojiArea" 
                            placeholder="Type your message and hit enter to send"
                            value={this.state.content} 
                            onChange={e => this.updateInput(e)}
                            onKeyDown={e => {
                                if(e.which === 13 && e.shiftKey === false){
                                    this.sendMessage();
                                }
                                
                            }}
                            ></textarea>
                            
                            <div className="files-temp row">
                            
                            {this.props.messageFiles.map((f, fi) => {
                                if (f.type.indexOf("image") > -1) {


                                                    return (
                                                        <div className="file-preview-container">
                                                            <button className={"btn btn-delete"}
                                                                    onClick={(e) => {
                                                                        this.props.cancelMessageFile(f, this.props.user.user.Profile.id, this.props.user.id)
                                                                    }}
                                                            ><i className={"zmdi zmdi-close"}/></button>
                                                            <img src={api.makeFileURL(f.url)} data-file={f.name}
                                                                 className="chapter-file-preview"/></div>
                                                    )
                                                } else if (f.type.indexOf("zip") > -1) {
                                                    return (
                                                        <a className="file-preview-container" target="_blank"
                                                           href={api.makeFileURL(f.url)}>
                                                            <button className={"btn btn-delete"}
                                                                    onClick={(e) => {
                                                                        this.props.cancelMessageFile(f, this.props.user.user.Profile.id, this.props.user.id)
                                                                    }}
                                                            ><i className={"zmdi zmdi-close"}/></button>
                                                            <i className="zmdi zmdi-folder"/>
                                                            <small>{f.name}</small>

                                                        </a>
                                                    )
                                                } else {
                                                    return (
                                                        <a className="file-preview-container" target="_blank"
                                                           href={api.makeFileURL(f.url)}>
                                                            <button className={"btn btn-delete"}
                                                                    onClick={(e) => {
                                                                        this.props.cancelMessageFile(f, this.props.user.user.Profile.id, this.props.user.id)
                                                                    }}
                                                            ><i className={"zmdi zmdi-close"}/></button>
                                                            <i className="zmdi zmdi-file"/>
                                                            <small>{f.name}</small>

                                                        </a>
                                                    )
                                                }
                            })
                            }
                            
                            {this.props.uploadingMessageFiles.map((f, fi) => {
                                
                                        if(f.type.indexOf("image") > -1){
                                            this.readFile(f);
                                            return (
                                                <div className="file-preview-container">
                                                    
                                                    <img src={""} data-file={f.name} className="chapter-file-preview" /></div>
                                            )
                                        }else if(f.type.indexOf("zip") > -1){
                                            return (
                                                <div className="file-preview-container">
                                                    
                                                    <i className="zmdi zmdi-folder" />
                                                    <small>{f.name}</small>

                                                </div>
                                            )
                                        }else{
                                            return (
                                                <div className="file-preview-container">
                                                    
                                                    <i className="zmdi zmdi-file" />
                                                    <small>{f.name}</small>

                                                </div>
                                            ) 
                                        }
                                    })}
                            </div>
                        </div>
                        : null
                        }
                </div>
                <div className={`chat-sidebar-right ${(this.state.sidebarOpened) ? 'active-chat-sidebar-right' : ''}`} >
                    <div className="mycs">
                        <div className="myc myc1"></div>
                        <div className="myc myc2"></div>
                        <div className="myc myc3"></div>
                    </div>
                    <div className="sp-20 sidebar-body">
                        <div className="flex flex-justify-content-space-between flex-align-items-center">
                            <p className="no-margin font-20 text-white">Gallery</p>
                            <a  className="font-22 line-height-1" onClick={e => this.setState({sidebarOpened: !this.state.sidebarOpened})}><i className="zmdi zmdi-close"></i> </a>
                        </div>
                        <div className="sm-top-bottom20 animateable animated fadeInRight">
                            <div className="form-group">
                                <select className="form-control" onChange={e => this.setState({activeAttachmentView: e.target.value})}>
                                    <option value="Pictures">Pictures</option>
                                    <option value="Files">Files</option>
                                    <option value="Links">Links</option>
                                </select>
                            </div>
                        </div>
                        <div className="sm-top-bottom20 animateable animated fadeInRight">
                            <div className="form-group">
                                <input type="text" className="form-control" placeholder="Search Files/Links" value={this.state.searchFiles} onChange={e => this.setState({searchFiles: e.target.value})}/>
                            </div>
                        </div>
                        <div className="sm-top-bottom20">
                            
                            <div className={`GalleryItem Gallery${this.state.activeAttachmentView}`} style={{display: 'block'}}>
                                <div className="chat-left-heading no-padding animateable wow  fadeInRight" data-wow-delay="0.1s" >
                                    <p>{this.state.activeAttachmentView}</p>
                                </div>
                                
                                {this.state.activeAttachmentView === 'Pictures' &&
                                    <div className="galleryPictureItems">
                                    
                                    
                                        {this.props.currentThread &&
                                            this.props.threads.filter(t => t.id === this.props.currentThread).length > 0 &&
                                            this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles &&
                                            this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles.filter(f => {
                                                
                                                return (this.state.searchFiles !== '') ? f.type.indexOf('image') > -1 && f.name.toLowerCase().indexOf(this.state.searchFiles.toLowerCase()) > -1 : f.type.indexOf('image') > -1;
                                                
                                                
                                            }).map((f, i) => {
                                                return (
                                                    <div className="galleryPictureItem animateable wow  fadeInRight" data-wow-delay="0.1s" style={{visibility: "visible", animationDelay: `0.${i}s`}}>
                                                        <div className="galleryPictureItemMeta">
                                                            {f.createdAt}
                                                        </div>
                                                        <a  ><img 
                                                            src={api.makeFileURL(f.url, this.props.user.id)} 
                                                            data-full-preview={api.makeFileURL(f.url, this.props.user.id)} 
                                                            title={f.name}
                                                            onClick={e => {
                                                                let newState = {galleryActive: true, galleryIndex: i};
                                                                this.setState(newState);
                                                                
                                                            }}    
                                                        /></a>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                                  
                                }
                                
                                
                                {this.state.activeAttachmentView === 'Files' &&
                                    <div className="galleryLinksItems">
                                    <ul>
                                        {this.props.currentThread &&
                                            this.props.threads.filter(t => t.id === this.props.currentThread).length > 0 &&
                                            this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles &&
                                            this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles.filter(f => {
                                                
                                                return (this.state.searchFiles !== '') ? f.type.indexOf('image') === -1 && f.name.toLowerCase().indexOf(this.state.searchFiles.toLowerCase()) > -1 : f.type.indexOf('image') === -1;
                                                
                                                
                                            }).map((f, i) => {
                                            
                                                return (
                                                    <li><a href={api.makeFileURL(f.url, this.props.user.id)}>{f.name}</a><span className="listItemDateMeta">{f.createdAt}</span></li>        
                                                )
                                            })
                                        }
                                        
                                       
                                    </ul>
                                </div>
                                }
                            </div>
                        </div>
                        <div className="">
                            <div className="sm-top20">
                                <div className="chat-left-heading no-padding  animateable wow  fadeInRight" data-wow-delay="0.6s">
                                    <p>Course Intructors</p>
                                </div>
                                <div className="peers_list">
                                    <ul>
                                    {this.props.currentThread && this.props.threads &&
                                        this.props.threads.filter(t => t.id === this.props.currentThread).length > 0 &&
                                        this.props.threads.filter(t => t.id === this.props.currentThread)[0].Profiles.map((t, i) => {
                                        if(t){
                                            let profile = t;
                                            if(profile){
                                              return (
                                                  <li>
                                                    
                                                        {profile.image ?
                                                                        <span>
                                                                            {profile.image.indexOf('http') === -1 ?
                                                                                <img src={api.makeFileURL(profile.image) || userImage}  />
                                                                            :
                                                                                <img src={(profile.image) ? profile.image : userImage}  />
                                                                            }
                                                                        </span>
                                                                        
                                                                        :
                                                                        <img src={(profile.image) ? profile.image : userImage}  />
                                                                    }
                                                        <h3>{profile.name} {profile.lname}</h3>
                                                        
                                                     
                                                    </li>
                                                )  
                                            }
                                        }
                                        })}
                                </ul>
                                </div>
                            </div>
                        </div>
            
                        <div className={`GalleryItemPreviewWrapper ${!this.state.galleryActive && 'GalleryPreviewInactive'}`}>
                        {this.props.threads &&
                            this.props.threads.length > 0 &&
                            this.props.currentThread &&
                            this.props.threads.filter(t => t.id === this.props.currentThread).length > 0 &&
                            this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles &&
                            this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles[this.state.galleryIndex] &&
                                
                                <div className="GalleryItemPreview">
                                    <div className="GalleryItemPreviewControls">
                
                                        <a  onClick={e => this.setState({galleryActive: false, galleryIndex: 0})} className="font-30 GalleryClose"><i className="zmdi zmdi-close"></i> </a>
                                        <a  className="GalleryNext" onClick={e => {
                                            if(this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles.length - 1 > this.state.galleryIndex){
                                                this.setState({galleryIndex: this.state.galleryIndex + 1});
                                            }else{
                                                this.setState({galleryIndex: 0});
                                            }
                                        }}><i className="zmdi zmdi-chevron-right"></i> </a>
                                        <a  className="GalleryPrev" onClick={e => {
                                        
                                            if(this.state.galleryIndex > 0){
                                                this.setState({galleryIndex: this.state.galleryIndex - 1});
                                            }else{
                                                this.setState({galleryIndex: this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles.length - 1});
                                            }
                                        }}><i className="zmdi zmdi-chevron-left"></i> </a>
                                    </div>
                                        
                                            <img src={api.makeFileURL(this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles[this.state.galleryIndex].url, this.props.user.id)} 
                                            id="GalleryImagePreviewItem" 
                                            title={this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles[this.state.galleryIndex].name} />
                                        
                                    <div className="GalleryImageMeta">
                                        <div className="">
                                            <h3 id="GalleryImageName">{this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles[this.state.galleryIndex].name}</h3>
                                        </div>
                                        <div>
                                            <a href={api.makeFileURL(this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles[this.state.galleryIndex].url, this.props.user.id)} target="_blank" className="btn btn-primary GalleryDownload"><i className="zmdi zmdi-download"></i> Download</a>
                                        </div>
                                    </div>
                                </div>
                                
                        }
                        </div>
                    </div>
                </div>
                
                
                
            </div>
            )
    }
}

export default TicketView;


// WEBPACK FOOTER //
// ./src/components/Chat/TicketView.js